import React from 'react';
import { useFormikContext } from 'formik';
import { FormFeedback } from 'Components/frameworks/form-feedback/FormFeedback';
import { Title } from 'Components/frameworks/title/Title';
import { scrollToElement } from 'Components/utils/scroll/scrollToElement';
import { HIPAY_PSP_ID } from 'Components/widgets/payment-info/PaymentInfo.const';
import { t } from 'Src/i18n';
import { Capsule } from 'Components/frameworks/capsule/Capsule';
import { FormikInput } from 'Components/frameworks/formik/FormikInput';
type Props = {
  shouldSubmitFormOnAccept: boolean;
  isDisabled: boolean;
  hasNoPaymentMethods?: boolean;
  healthRegulations: any;
};
export const HealthRegulations = ({
  shouldSubmitFormOnAccept,
  isDisabled,
  healthRegulations,
  hasNoPaymentMethods = false,
}: Props) => {
  const formik = useFormikContext();

  const submitFormOnAccept = ({ currentTarget }) => {
    const shouldProceedToSubmit = currentTarget.checked;

    if (shouldSubmitFormOnAccept && shouldProceedToSubmit && formik.values.paymentMethodId) {
      // submit form if asked and all the cgv are checked and a paymentMethodId is selected
      // should wait for validation to be done
      setTimeout(formik.submitForm, 0);
    }

    if (
      hasNoPaymentMethods &&
      shouldProceedToSubmit &&
      formik.values.paymentProviderId === HIPAY_PSP_ID &&
      formik.values.termsAndConditions.cgv
    ) {
      setTimeout(() => {
        formik.submitForm();
        scrollToElement('#payment-form-iframe');
      }, 500);
    }
  };

  const hasCGVError =
    formik.errors?.HealthRegulations &&
    formik.touched?.HealthRegulations &&
    formik.errors?.HealthRegulations.cgv &&
    formik.touched?.HealthRegulations.cgv;
  return (
    <div data-testid="Contract-info-block">
      <Title className="mb-10" id="HealthRegulationsTitleId" theme="title-brand-n2">
        {healthRegulations.label}
      </Title>
      <Capsule header="none" contentClassName="p-20">
        <FormikInput
          isDisabled={isDisabled}
          isRequired
          label={
            <React.Fragment>
              <span>{healthRegulations.description}</span>
              <span>
                <a
                  className="text-inherit underline"
                  href={healthRegulations.url}
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  {t('booking.banking.healthRegulation.termsOfSales')}
                </a>
              </span>
            </React.Fragment>
          }
          name="HealthRegulations.cgv"
          onChange={submitFormOnAccept}
          type="checkbox"
        />
      </Capsule>
      {hasCGVError && (
        <div id="HealthRegulations-cgv-error" aria-live="polite">
          <FormFeedback isError message={t('booking.banking.healthRegulation.errorMessage')} />
        </div>
      )}
    </div>
  );
};
